<template>
	<ActivityLayout class="goal-kr-type-activity">
		<template #badge>
			<TypeChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="translate( `text`, {
				name: activity.name,
				changedBy: activity.changedBy,
				to: activity.to,
				from: activity.from,
			} )"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import TypeChangeActivityBadge from "../Activity/TypeChangeActivityBadge.vue";

export default {
	name: "GoalKRTypeActivity",
	components: {
		ActivityLayout,
		TypeChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, name:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalKRTypeActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
